import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DirectorioService {
  constructor(private http: HttpClient) { }

  getDirectorio() {
    //return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Directorio?Zona=General");
    return this.http.get("assets/data/directorio.json");
  }
  getGerNorte() {
      return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Directorio?Zona=Norte");
  }
  getGerCentro() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Directorio?Zona=Centro");
  }
  getGerSur() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Directorio?Zona=Sur");
  }

}
